var chunkToChildrenMap = {
	"316": [
		184,
		235,
		639,
		531,
		819,
		609,
		389,
		163
	]
};
__webpack_require__.f.prefetch = (chunkId, promises) => (Promise.all(promises).then(() => {
	var chunks = chunkToChildrenMap[chunkId];
	Array.isArray(chunks) && chunks.map(__webpack_require__.E);
}));